import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Trademark Upgrades - Professional Trademark Registration Services USA",
  description = "Protect your brand with expert trademark registration services. Fast, affordable, and hassle-free trademark filing with 98% success rate. Starting at just $45.",
  keywords = "trademark registration, trademark services, copyright registration, company formation, brand protection, USPTO, trademark attorney, intellectual property, Amazon brand registry",
  canonical = window.location.href,
  type = "website"
}) => {
  const siteName = "Trademark Upgrades";
  const fullTitle = title.includes(siteName) ? title : `${title} | ${siteName}`;
  
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonical} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content={siteName} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonical} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      
      {/* Additional SEO Tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta name="author" content={siteName} />
    </Helmet>
  );
};

export default SEO;
